module.exports = __webpack_public_path__ + "static/icons/caret-left-1b48e8aa94ebecd1a41169dd946d0b53.svg";